export default __webpack_public_path__ + "static/logo-5626d2bbd990d9263303327685c97a1f.png";